// Fired on window after the access token was refreshed.
export const TOKEN_REFRESHED_EVENT = "rosi:token-refreshed";

// A refresh the backend refused (expired / replaced / unknown refresh token).
// A network failure or a 5xx is not a reason to end the session.
export const isRefreshRejected = (failure) =>
  [400, 401, 403].includes(failure?.statusCode);

// Set before the forced redirect to /signin (the page reloads, so a toast
// shown then would be lost); the Sign In page shows the message once.
const SESSION_EXPIRED_KEY = "rosi:session-expired";
export const SESSION_EXPIRED_MESSAGE =
  "Your session has expired, please sign in again.";

export const markSessionExpired = () => {
  try {
    sessionStorage.setItem(SESSION_EXPIRED_KEY, "1");
  } catch (e) {}
};

// True once after markSessionExpired, then false until it is set again.
export const takeSessionExpired = () => {
  try {
    const expired = sessionStorage.getItem(SESSION_EXPIRED_KEY) === "1";
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
    return expired;
  } catch (e) {
    return false;
  }
};
